export const IS_APPLE: boolean = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
